import type { EventDto } from 'api/generated';
import { getDateParts } from './date-helpers';

/**
 * Group events into calendar-day buckets (keyed by day-of-month) for the
 * viewed month, evaluating each event's day in the venue timezone. Events
 * outside the viewed month are dropped.
 */
export function groupEventsByServerDay(events: EventDto[], viewYear: number, viewMonth: number, serverTimezone: string): Record<number, EventDto[]> {
  return events.reduce<Record<number, EventDto[]>>((acc, event) => {
    const {
      year,
      month,
      day
    } = getDateParts(event.startDate ?? 0, serverTimezone);
    if (year !== viewYear || month !== viewMonth) return acc;
    (acc[day] ??= []).push(event);
    return acc;
  }, {});
}

/**
 * Localized name of a 0-based month index. The sample date is anchored to
 * UTC and formatted with an explicit UTC timezone, so the name is
 * independent of both the browser timezone and the Intl polyfill's default
 * timezone (which is UTC, not the browser's — formatting a locally
 * constructed date with it shifts the month for buyers ahead of UTC).
 */
export function getMonthName(locale: string, monthIndex: number, format: 'short' | 'long' = 'short'): string {
  return new Date(Date.UTC(2020, monthIndex, 1)).toLocaleString(locale, {
    month: format,
    timeZone: 'UTC'
  });
}